import type { PbrStage } from '../../../types/cultivar';
import { PBR_STAGE_LABELS } from '../../../types/cultivar';

const STAGE_STYLES: Record<PbrStage, string> = {
  candidate: 'bg-neutral-100 text-neutral-700',
  part1_prep: 'bg-blue-100 text-blue-700',
  part1_submitted: 'bg-indigo-100 text-indigo-700',
  accepted: 'bg-teal-100 text-teal-700',
  trial_in_progress: 'bg-amber-100 text-amber-700',
  part2_prep: 'bg-violet-100 text-violet-700',
  part2_submitted: 'bg-purple-100 text-purple-700',
  granted: 'bg-emerald-100 text-emerald-700',
  ceased: 'bg-neutral-200 text-neutral-500',
  rejected: 'bg-red-100 text-red-700',
  withdrawn: 'bg-neutral-200 text-neutral-500',
};

interface Props {
  stage: PbrStage;
  className?: string;
}

export default function PbrStageBadge({ stage, className = '' }: Props) {
  const style = STAGE_STYLES[stage] || 'bg-neutral-100 text-neutral-700';
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${style} ${className}`}>
      {PBR_STAGE_LABELS[stage] || stage}
    </span>
  );
}
